import { render } from "./conversations.vue?vue&type=template&id=192d0d26"
import script from "./conversations.vue?vue&type=script&lang=js"
export * from "./conversations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__